module.exports = __webpack_public_path__ + "img/bird.3a42b22e.png";